// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2tOzc","modalFooterButton":"ModalNotes_modalFooterButton__6PiEy"};